export default "__VITE_ASSET__Cx4NBZVA__"